export const LOCAL_STORAGE_VOICEPRINT_KEY = 'my_voiceprint';
export const LOCAL_STORAGE_USER_TOKEN_KEY = 'user_token';
export const LOCAL_STORAGE_JWT_KEY = 'ekoz_jwt';
